import colors from 'assets/theme/base/colors';

const { text } = colors;

const chip = {
  styleOverrides: {
    root: {
      color: text.main
    }
  }
};

export default chip;
